import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import viberCampaign from './modules/viberCampaign'
import smsCampaign from './modules/smsCampaign'
import recurringViberCampaign from './modules/recurringViberCampaign'
import recurringSmsCampaign from './modules/recurringSmsCampaign'
import arrayFilters from './modules/arrayFilters'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        viberCampaign,
        smsCampaign,
        recurringViberCampaign,
        recurringSmsCampaign,
        arrayFilters
    }
})
